import log from "loglevel";
import {
  Account,
  AccountDropdownItemType,
  AccountUser,
  AccountUserDropdownItemType,
  User,
  UserDropdownItemType,
  Role,
  RoleDropdownItemType,
  Team,
  TeamDropdownItemType,
  TeamUser,
  TeamUserDropdownItemType
} from "types";

export const generateAccountDropdownItems = (accounts: Account[]) => {
  if (accounts) {
    return accounts.map(function(account) {
      const accountDropdownItem: AccountDropdownItemType = {
        id: account.id,
        label: account.name,
        account: account
      };
      return accountDropdownItem;
    });
  }
};

export const generateAccountUserDropdownItems = (
  accountUsers: AccountUser[],
  filterByAccountId?: number
) => {
  if (accountUsers) {
    if (filterByAccountId) {
      log.info("Filtering by Account ID: " + filterByAccountId);
    } else {
      log.info("No Account ID provided, will not filter.");
    }
    return accountUsers
      .filter(accountUser => {
        if (filterByAccountId) {
          return accountUser.account_id === filterByAccountId;
        } else {
          return true;
        }
      })
      .map(function(accountUser) {
        const accountUserDropdownItem: AccountUserDropdownItemType = {
          id: accountUser.id,
          label: accountUser.username,
          accountUser: accountUser
        };
        return accountUserDropdownItem;
      });
  }
};

export const generateUserDropdownItems = (users: User[]) => {
  if (users) {
    return users.map(function(user) {
      const userDropdownItem: UserDropdownItemType = {
        id: user.id,
        label: `${user.username} (${user.first_name} ${user.last_name})`,
        user: user
      };
      return userDropdownItem;
    });
  }
};

export const generateTeamDropdownItems = (team: Team[]) => {
  if (team) {
    return team.map(function(team) {
      const teamDropdownItem: TeamDropdownItemType = {
        id: team.id,
        label: `${team.name} (${team.account_name})`,
        team: team
      };
      return teamDropdownItem;
    });
  }
};

export const generateTeamUserDropdownItems = (teamUsers: TeamUser[]) => {
  if (teamUsers) {
    return teamUsers.map(function(teamUser) {
      const teamUserDropdownItem: TeamUserDropdownItemType = {
        id: teamUser.id,
        label: `${teamUser.username} (${teamUser.account_name})`,
        teamUser: teamUser
      };
      return teamUserDropdownItem;
    });
  }
};

export const generateRoleDropdownItems = (
  roles: Role[],
  disableRoleId: number = 0
) => {
  if (roles) {
    return roles.map(function(role) {
      const roleDropdownItem: RoleDropdownItemType = {
        id: role.id,
        label: role.name,
        role: role,
        disabled: role.id === disableRoleId ? "yes" : "no"
      };
      return roleDropdownItem;
    });
  }
};
